import {
    Component,
    Input,
    OnInit,
    ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';
import { FooterComponent } from '../footer.component';

@Component({
    selector: 'footer-dynamic',
    templateUrl: './footer-dynamic.component.html',
    styleUrls: ['./footer-dynamic.component.scss']
})

export class FuseFooterComponentDynamic implements OnInit {
    @Input() public RefFooterComponent : any;
        
    constructor(private vcr : ViewContainerRef, private cfr : ComponentFactoryResolver) {
        
    }

    ngOnInit(){
        if(this.RefFooterComponent){
            this.vcr.createComponent(this.RefFooterComponent);
        }else{
            let myComp = this.cfr.resolveComponentFactory(FooterComponent);
            this.vcr.clear();
            this.vcr.createComponent(myComp);
        }
       
        
    }
    
}
